import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inco-validation',
  templateUrl: './inco-validation.component.html',
  styleUrls: ['./inco-validation.component.less'],
  standalone: false
})
export class IncoValidationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
